import { useEffect, useState } from "react";

function diff(target) {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  return {
    done: ms === 0,
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms / 3600000) % 24),
    m: Math.floor((ms / 60000) % 60),
    s: Math.floor((ms / 1000) % 60),
  };
}

export const Countdown = ({ target, testid = "countdown", light = false }) => {
  const [t, setT] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target || isNaN(new Date(target))) return null;
  if (t.done) {
    return <p className="h-display text-3xl text-gold" data-testid={`${testid}-done`}>It's game day.</p>;
  }
  const units = [["Days", t.d], ["Hours", t.h], ["Min", t.m], ["Sec", t.s]];
  return (
    <div className="flex gap-2 sm:gap-3" data-testid={testid}>
      {units.map(([label, v]) => (
        <div key={label} className={`min-w-[64px] sm:min-w-[88px] px-3 py-3 sm:py-4 text-center ${light ? "bg-navy" : "bg-pitch/70 border border-line"}`}>
          <div className="font-display text-3xl sm:text-5xl font-black text-gold tabular-nums leading-none" data-testid={`${testid}-${label.toLowerCase()}`}>
            {String(v).padStart(2, "0")}
          </div>
          <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">{label}</div>
        </div>
      ))}
    </div>
  );
};
